module.exports = __webpack_public_path__ + "media/audio24.8b1ab21c.mp3";